let Brandfocus_data1_2 =[
    {
        id : 34,
        imgurl : 'img/section5/section5_1_3.jpg',
        brand : 'STANDIAL',
        title : 'Butterfly Knit Bucket Hat_PINK',
        persent : '10%',
        price : '53,100',
    },
    {
        id : 35,
        imgurl : 'img/section5/section5_1_4.jpg',
        brand : 'STANDIAL',
        title : 'Color Block Swimsuit_BLACK',
        persent : '10%',
        price : '107,100',
    },
    {
        id : 36,
        imgurl : 'img/section5/section5_1_5.jpg',
        brand : 'STANDIAL',
        title : 'Crochet Collar Cardigan_GREEN',
        persent : '10%',
        price : '107,100',
    },
    {
        id : 37,
        imgurl : 'img/section5/section5_1_6.jpg',
        brand : 'JOSEPH&STACEY',
        title : 'Lucky Pleats Knit Daisy Garden',
        persent : '14%',
        price : '51,130',
    },
    {
        id : 38,
        imgurl : 'img/section5/section5_1_7.jpg',
        brand : 'JOSEPH&STACEY',
        title : 'Lucky Pleats Knit M',
        persent : '9%',
        price : '53,970',
    },
    {
        id : 39,
        imgurl : 'img/section5/section5_1_8.jpg',
        brand : 'JOSEPH&STACEY',
        title : 'LPK Lattice Knit Tote Bag',
        persent : '9%',
        price : '162,270',
    }
]

export default Brandfocus_data1_2;